import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ShopService } from '../shop.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.css']
})
export class NavComponent implements OnInit {

  public isNavbarCollapsed:boolean;
  public activated:boolean;

  // public cartCount = () => (this.shop.checkout && this.shop.checkout.lineItems) ? (
  //   this.shop.checkout.lineItems.reduce(function (total, obj) {
  //     return total + obj.quantity;
  //   }, 0)
  // ) : 0;

  navItems = [
    {
      label: "videos",
      route: "/videos"
    },
    {
      label: "blog",
      route: "/posts"
    },
    {
      label: "history",
      route: "/history"
    },
    // {
    //   label: "shop",
    //   route: "/products"
    // },
    // {
    //   label: "team",
    //   route: "/team"
    // },
    // {
    //   label: "history",
    //   route: "/history"
    // }
  ];

  go(route: string, event: Event): void {
    event.stopPropagation();
    this.router.navigate([route]);
  }

  activeTab(route: string): boolean {
    return this.router.url === route;
  }

  constructor(private router: Router, private shop: ShopService) { }

  ngOnInit() {
  }
}


// WEBPACK FOOTER //
// /tmp/build_fdb7fa8d/src/app/nav/nav.component.ts